import moment from "moment";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { InputAdornment, Stack, Typography, Box } from "@mui/material";
import { useResponsive } from "../../hooks/useResponsive";
import { worklogMissingSchemas } from "../../schemas/worklogMissing";
import { RFHTextField as RHFTextField, RHFRadioGroup } from '../RFH'
import useMutate from "../../hooks/useMutate";
import { createtMissingWorklog } from "../../sevices/apiWorklog";
import { useSelector } from "react-redux";
import { CustomButton } from "../Button/Button";

function WorklogMissingForm({ date, time, handleClose, dayName }) {
  const isMobile = useResponsive("down", "md");
  const currentUser = useSelector((state) => state.users.logInUser);
  const methods = useForm({
    resolver: yupResolver(worklogMissingSchemas),
    defaultValues: {},
  });
  const { mutate, isPending } = useMutate(
    createtMissingWorklog,
    ["worklog-missing"],
    () => {
      handleClose();
    }
  );

  const onSubmit = async (formData) => {
    const data = {
      user_id: currentUser.user_id,
      leave_date: date,
      ...formData,
    };
    mutate(data);
  };
  const leaveTypeOptions = [
    { value: "Weekend", label: "Weekend" },
    { value: "Holiday", label: "Company Holiday" },
    { value: "Personal Leave", label: "Personal Leave" },
  ];
  return (
    <div>
      <div className="missing-worklog-list-containor">
        <div className="d-flex justify-content-space-between">
          <p className="note">Worklog missing</p>
          <p className="date-hour">{`${dayName} ${moment(date).format(
            "MMM DD, YYYY"
          )} (${time?.toFixed(2)} hrs)`}</p>
        </div>
        <FormProvider {...methods}>
          <div>
            <form onSubmit={methods.handleSubmit(onSubmit)}>
              <div>
                <Stack spacing={2}>
                  <RHFRadioGroup
                    name={"leave_type"}
                    options={leaveTypeOptions}
                    className={"worklog-missing-reason-options"}
                    row={3}
                    isCircularRadio={true}
                  />
                  <RHFTextField
                    name="reason"
                    placeholder={"Enter Reason (Optional).."}
                    defaultPadding={true}
                    className="worklog-missing-reason-input"
                    multiline
                    rows={2}
                  />
                </Stack>
              </div>

              <Box className="form-actions">
                <CustomButton
                  type="submit"
                  sx={{ padding: "8px 32px" }}
                  className="theme-bg-color mr-2"
                  disabled={isPending}
                >
                  Submit
                </CustomButton>
                <CustomButton onClick={handleClose} disabled={isPending}>
                  Cancel
                </CustomButton>
              </Box>
            </form>
          </div>
        </FormProvider>
      </div>
    </div>
  );
}

export default WorklogMissingForm;
